export default __webpack_public_path__ + "942930f45fd6a5358d5ca8ca0acc6ded.gif";